import React, { useEffect, useRef } from 'react';
import { useTranslate } from '@hooks';
import { Code as CodeIcon } from 'react-feather';
import {
  ModalWithInitialButton as Modal,
  TextareaClipboard,
  FlexContainer,
} from '@dotone/react-ui-core';

const OfferEmbeddedSignup = ({ embedScript, ...otherProps }) => {
  const { t } = useTranslate('common', 'actions');
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !embedScript) return;

    const range = document.createRange();
    range.selectNode(containerRef.current);
    const fragment = range.createContextualFragment(embedScript);
    containerRef.current.innerHTML = '';
    containerRef.current.appendChild(fragment);
  }, [embedScript]);

  return (
    <FlexContainer column align="center" justify="end" {...otherProps}>
      <div ref={containerRef} />
      <Modal
        dense
        title={t('getCode')}
        footer={false}
        buttonProps={{
          color: 'primary',
          size: 'sm',
          className: 'btn-rounded mt-2',
          children: (
            <>
              <CodeIcon size={14} className="mr-1" />
              {t('getCode')}
            </>
          ),
        }}
      >
        <TextareaClipboard value={embedScript} />
      </Modal>
    </FlexContainer>
  );
};

export default OfferEmbeddedSignup;
